import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';

import { AccountService } from '../services/services.module';

@Injectable()
export class AuthGuard implements CanActivate {
  originRoute: ActivatedRouteSnapshot;
  constructor(private router: Router, private accountService: AccountService, private route: ActivatedRoute) {}

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
    if (this.accountService.currentUser) {
      return true;
    } else {
      return this.accountService
        .currentUserAsync()
        .then(() => {
          if (this.accountService.currentUser) {
            return true;
          }
        })
        .catch(() => {
          if (route.routeConfig.path === 'crm') {
            if (route.firstChild.params.id) {
              this.accountService.emitId({ eventId: route.queryParams, profile: route.firstChild.params.id });
            } else {
              this.accountService.emitId({ [route.firstChild.routeConfig.path]: route.queryParams });
            }
          }
          this.router.navigate(['/signin']);
          return false;
        });
    }
  }
}
